import {
  EditBlockSelect,
  EditBlockColorPicker,
  EditBlockTextInput,
  EditBlockSwitch,
} from '@components/EditBuildingBlocks/all'
import genericContentItemEditor from '@components/mixins/genericContentItemEditor'

export default {
  name: 'RankEditorComponent',
  mixins: [genericContentItemEditor],
  components: {
    'edit-block-select': EditBlockSelect,
    'edit-block-color-picker': EditBlockColorPicker,
    'edit-block-text-input': EditBlockTextInput,
    'edit-block-switch': EditBlockSwitch,
  },
  data() {
    return {}
  },
  computed: {
    //= =============STYLING
    rankIconColor: {
      get() {
        return this.component.styling.baseColor
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['baseColor'],
          data: value,
        })
      },
    },
    //= =============SETTINGS
    rankLabel: {
      get() {
        return this.component.settings.label
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['settings'],
          attribute: ['label'],
          data: value,
        })
      },
    },
    rankRequired: {
      get() {
        return this.component.settings.required
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['settings'],
          attribute: ['required'],
          data: value,
        })
      },
    },
    rankItemCount: {
      get() {
        return this.component.settings.count
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['settings'],
          attribute: ['count'],
          data: value,
        })
      },
    },
    rankType: {
      get() {
        return this.component.settings.type
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['settings'],
          attribute: ['type'],
          data: value,
        })
      },
    },
  },
}
